import { BaseController } from '@maia/feature-utils';
import { AttachmentDto, AttachmentService } from '@maia/shared';

export class AttachmentController extends BaseController {
  constructor(private attachmentsService: AttachmentService) {
    super();
  }

  async findMany(search: Record<string, unknown>) {
    const response = await this.getEntities(
      this.attachmentsService,
      { path: '', search },
      AttachmentDto,
    );

    return response;
  }

  async find(guid: string) {
    const response = await this.getEntity(
      this.attachmentsService,
      guid,
      AttachmentDto,
    );
    return response;
  }
}
